export default {"src":"/_next/static/media/my-personal-information.e6884246.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};